{
  "loan-estimate-table-title": "Loan Estimate",
  "final": "Final",
  "did-this-change": "Did this change?",
  "total-closing-costs": "Total Closing Cost (J)",
  "paid-before-closing": "Paid Before Closing",
  "closing-costs-financed": "Closing Costs Financed",
  "down-payment-from-borrower": "Down Payment From Borrower",
  "deposit": "Deposit",
  "funds-for-borrower": "Funds For Borrower",
  "seller-credits": "Seller Credits",
  "adjustments-other-credits": "Adjustments / Other Credits",
  "cash-to-close": "Cash To Close",
  "yes-option": "Yes",
  "no-option": "No"
}
